import styles from '../styles/CustomDateInput.module.css';

const CustomDateInput = ({ value, onChange }) => {
  return (
    <div className={styles.wrapper}>
      <input
        type="date"
        placeholder='Фильтр по дате создания'
        className={styles.dateInput}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default CustomDateInput;
